import { client } from '../client';
import { INotification } from './types/INotification';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const acknowledgeNotificationById = async (
  notification_id: number,
  userRole?: string,
): Promise<INotification> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post(`${prefix}/notifications/${notification_id}`);

  return data;
};
